'use strict';
/* eslint-disable react/jsx-handler-names, no-shadow */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _WidgetData = require('conversations-schema/records/WidgetData');

var _WidgetData2 = _interopRequireDefault(_WidgetData);

var _Conversation = require('conversations-schema/records/Conversation');

var _Conversation2 = _interopRequireDefault(_Conversation);

var _requestStatusSelectors = require('conversations-core/selectors/requestStatusSelectors');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _widgetDataSelectors = require('conversations-core/selectors/widgetDataSelectors');

var _pubNubStatusSelectors = require('conversations-core/selectors/pubNubStatusSelectors');

var _chatSelectors = require('conversations-visitor-ui/selectors/chatSelectors');

var _widgetUiSelectors = require('conversations-visitor-ui/selectors/widgetUiSelectors');

var _PublishActions = require('conversations-core/actions/PublishActions');

var _PubNubPresenceActions = require('conversations-core/actions/PubNubPresenceActions');

var _VisitorEmailAddressActions = require('conversations-visitor-ui/actions/VisitorEmailAddressActions');

var _ChatHistoryActions = require('conversations-core/actions/ChatHistoryActions');

var _MeetingsActions = require('conversations-core/actions/MeetingsActions');

var _WidgetActions = require('conversations-visitor-ui/actions/WidgetActions');

var _ConversationsActions = require('conversations-core/actions/ConversationsActions');

var _WidgetManager = require('conversations-core/components/widget/WidgetManager');

var _WidgetManager2 = _interopRequireDefault(_WidgetManager);

var _RequestStatusTypes = require('conversations-schema/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

var _conversationSelectors = require('conversations-core/selectors/conversationSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IndexContainer = _react2.default.createClass({
  displayName: 'IndexContainer',

  propTypes: {
    currentConversation: _react.PropTypes.instanceOf(_Conversation2.default),
    widgetData: _react.PropTypes.instanceOf(_WidgetData2.default),
    chatHistoryFetchStatus: _react.PropTypes.oneOf(Object.keys(_RequestStatusTypes2.default)).isRequired,
    publishChatMessage: _react.PropTypes.func.isRequired,
    publishOfflineMessage: _react.PropTypes.func.isRequired,
    republishMessage: _react.PropTypes.func.isRequired,
    sendVisitorEmailAddress: _react.PropTypes.func.isRequired,
    fetchPublicChatHistory: _react.PropTypes.func.isRequired,
    fetchInitialPublicChatHistory: _react.PropTypes.func.isRequired,
    clickedMeetingsLink: _react.PropTypes.func.isRequired,
    clickedForUserDescription: _react.PropTypes.func.isRequired,
    prospectUtks: _react.PropTypes.object.isRequired,
    currentChannel: _react.PropTypes.string,
    mobile: _react.PropTypes.bool,
    chatInputChanged: _react.PropTypes.func.isRequired,
    showTypingIndicator: _react.PropTypes.bool,
    isOnlineMode: _react.PropTypes.bool,
    displayResponderOnline: _react.PropTypes.bool.isRequired,
    widgetDataStatus: _react.PropTypes.oneOf(Object.keys(_RequestStatusTypes2.default)).isRequired,
    serverTimeOffsetStatus: _react.PropTypes.oneOf(Object.keys(_RequestStatusTypes2.default)).isRequired,
    open: _react.PropTypes.bool.isRequired,
    hideWelcomeMessage: _react.PropTypes.bool.isRequired,
    liveChatLink: _react.PropTypes.string,
    onLinkClick: _react.PropTypes.func.isRequired,
    clearUnseenCount: _react.PropTypes.func,
    showEmailCapture: _react.PropTypes.bool.isRequired,
    emailCaptureMessageIndex: _react.PropTypes.number,
    emailCaptureMessage: _react.PropTypes.string.isRequired,
    visiblyOffline: _react.PropTypes.bool.isRequired,
    onUpdateSize: _react.PropTypes.func.isRequired,
    onUpdateOpened: _react.PropTypes.func.isRequired,
    onHideWelcomeMessage: _react.PropTypes.func.isRequired,
    hasUnansweredQuickReplyMessage: _react.PropTypes.bool,
    isAgentReady: _react.PropTypes.bool
  },

  handleFetchNextHistory: function handleFetchNextHistory(channel, startTime) {
    this.props.fetchPublicChatHistory({
      channel: channel,
      startTime: startTime
    });
  },
  handlePublishMessage: function handlePublishMessage(_ref) {
    var text = _ref.text,
        richText = _ref.richText;

    if (this.props.isOnlineMode) {
      this.props.publishChatMessage({ text: text, richText: richText });
    } else {
      this.props.publishOfflineMessage({ text: text, richText: richText });
    }
  },
  isReady: function isReady() {
    var _props = this.props,
        currentChannel = _props.currentChannel,
        widgetDataStatus = _props.widgetDataStatus,
        widgetData = _props.widgetData;


    var hasWidgetData = widgetDataStatus === _RequestStatusTypes2.default.SUCCEEDED;
    var chatMethodAvailable = currentChannel || !widgetData.responder.online;

    return hasWidgetData && chatMethodAvailable;
  },
  render: function render() {
    var _React$createElement;

    var _props2 = this.props,
        widgetData = _props2.widgetData,
        currentChannel = _props2.currentChannel,
        currentConversation = _props2.currentConversation,
        clickedMeetingsLink = _props2.clickedMeetingsLink,
        clickedForUserDescription = _props2.clickedForUserDescription,
        republishMessage = _props2.republishMessage,
        mobile = _props2.mobile,
        chatInputChanged = _props2.chatInputChanged,
        showTypingIndicator = _props2.showTypingIndicator,
        chatHistoryFetchStatus = _props2.chatHistoryFetchStatus,
        open = _props2.open,
        hideWelcomeMessage = _props2.hideWelcomeMessage,
        clearUnseenCount = _props2.clearUnseenCount,
        showEmailCapture = _props2.showEmailCapture,
        emailCaptureMessageIndex = _props2.emailCaptureMessageIndex,
        emailCaptureMessage = _props2.emailCaptureMessage,
        visiblyOffline = _props2.visiblyOffline,
        onUpdateSize = _props2.onUpdateSize,
        onUpdateOpened = _props2.onUpdateOpened,
        onHideWelcomeMessage = _props2.onHideWelcomeMessage,
        liveChatLink = _props2.liveChatLink,
        onLinkClick = _props2.onLinkClick,
        hasUnansweredQuickReplyMessage = _props2.hasUnansweredQuickReplyMessage,
        isAgentReady = _props2.isAgentReady,
        displayResponderOnline = _props2.displayResponderOnline,
        isOnlineMode = _props2.isOnlineMode,
        sendVisitorEmailAddress = _props2.sendVisitorEmailAddress;


    if (!this.isReady()) {
      return null;
    }

    return _react2.default.createElement(_WidgetManager2.default, (_React$createElement = {
      widgetData: widgetData,
      currentChannel: currentChannel,
      currentConversation: currentConversation,
      clickedMeetingsLink: clickedMeetingsLink,
      clickedForUserDescription: clickedForUserDescription,
      chatHistoryFetchStatus: chatHistoryFetchStatus,
      republishMessage: republishMessage,
      publishMessage: this.handlePublishMessage,
      sendVisitorEmailAddress: sendVisitorEmailAddress,
      fetchNextHistory: this.handleFetchNextHistory,
      fetchInitialHistory: this.props.fetchInitialPublicChatHistory,
      displayResponderOnline: displayResponderOnline,
      isOnlineMode: isOnlineMode,
      mobile: mobile,
      preview: false,
      chatInputChanged: chatInputChanged,
      showTypingIndicator: showTypingIndicator
    }, _defineProperty(_React$createElement, 'displayResponderOnline', displayResponderOnline), _defineProperty(_React$createElement, 'open', open), _defineProperty(_React$createElement, 'hideWelcomeMessage', hideWelcomeMessage), _defineProperty(_React$createElement, 'liveChatLink', liveChatLink), _defineProperty(_React$createElement, 'onLinkClick', onLinkClick), _defineProperty(_React$createElement, 'clearUnseenCount', clearUnseenCount), _defineProperty(_React$createElement, 'showEmailCapture', showEmailCapture), _defineProperty(_React$createElement, 'emailCaptureMessage', emailCaptureMessage), _defineProperty(_React$createElement, 'emailCaptureMessageIndex', emailCaptureMessageIndex), _defineProperty(_React$createElement, 'visiblyOffline', visiblyOffline), _defineProperty(_React$createElement, 'onUpdateSize', onUpdateSize), _defineProperty(_React$createElement, 'onUpdateOpened', onUpdateOpened), _defineProperty(_React$createElement, 'onHideWelcomeMessage', onHideWelcomeMessage), _defineProperty(_React$createElement, 'hasUnansweredQuickReplyMessage', hasUnansweredQuickReplyMessage), _defineProperty(_React$createElement, 'isAgentReady', isAgentReady), _React$createElement));
  }
});

exports.default = (0, _reactRedux.connect)(function (state) {
  var widgetData = state.widgetData,
      requestStatus = state.requestStatus,
      currentChannel = state.currentChannel,
      prospectUtks = state.prospectUtks,
      typing = state.typing;


  return {
    widgetData: widgetData,
    widgetDataStatus: requestStatus.widgetData,
    serverTimeOffsetStatus: requestStatus.serverTimeOffsetStatus,
    chatHistoryFetchStatus: (0, _requestStatusSelectors.getCurrentChatHistoryStatus)(state),
    currentConversation: (0, _conversationSelectors.getCurrentConversation)(state),
    showTypingIndicator: typing.get('showTypingIndicator'),
    displayResponderOnline: (0, _clientSelectors.getDisplayResponderOnline)(state),
    isOnlineMode: (0, _widgetDataSelectors.getIsOnlineMode)(state),
    showEmailCapture: (0, _chatSelectors.shouldShowEmailCapture)(state),
    emailCaptureMessage: (0, _widgetDataSelectors.getAskForEmailMessage)(state),
    emailCaptureMessageIndex: (0, _chatSelectors.getEmailCaptureMessageIndex)(state),
    prospectUtks: prospectUtks,
    currentChannel: currentChannel,
    mobile: (0, _widgetUiSelectors.getIsMobile)(state),
    open: (0, _widgetUiSelectors.getIsOpen)(state),
    hideWelcomeMessage: (0, _widgetUiSelectors.getShouldHideWelcomeMessage)(state),
    liveChatLink: (0, _widgetDataSelectors.liveChatLink)(state),
    visiblyOffline: (0, _pubNubStatusSelectors.getIsVisiblyOffline)(state),
    hasUnansweredQuickReplyMessage: (0, _chatSelectors.hasUnansweredQuickReplyMessage)(state),
    isAgentReady: (0, _clientSelectors.getIsAgentReady)(state)
  };
}, {
  push: _reactRouterRedux.push,
  publishChatMessage: _PublishActions.publishChatMessage,
  publishOfflineMessage: _PublishActions.publishOfflineMessage,
  republishMessage: _PublishActions.republishMessage,
  chatInputChanged: _PubNubPresenceActions.chatInputChanged,
  sendVisitorEmailAddress: _VisitorEmailAddressActions.sendVisitorEmailAddress,
  fetchPublicChatHistory: _ChatHistoryActions.fetchPublicChatHistory,
  fetchInitialPublicChatHistory: _ChatHistoryActions.fetchInitialPublicChatHistory,
  clickedMeetingsLink: _MeetingsActions.clickedMeetingsLink,
  onLinkClick: _WidgetActions.clickedViralLink,
  clickedForUserDescription: _WidgetActions.clickedForUserDescription,
  clearUnseenCount: _ConversationsActions.clearUnseenCount
})(IndexContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/containers/IndexContainer.js
// module id = 415
// module chunks = 0 1